import React from 'react';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';

const useStyles = buildUseStyles('RequestChurnCancelButton', theme => ({
  root: {
    textAlign: 'left',
  },

  link: {
    color: theme.palette.facet.accentBlue,
    cursor: 'pointer',
  },
}));

const RequestChurnCancel = ({
  resource,
}) => {
  const classes = useStyles();
  const { loadModalCollectionByLink } = useModalContext();

  const handleClick = () => {
    const selectLink = resource
      .relationship(fr.relationships.requestChurnCancel.name)
      .link('related')
      .url();

    loadModalCollectionByLink(selectLink);
  };

  return (
    <BodyText
      className={classes.root}
      text={(
                <>
                  {resource.attr('detail')}
                  <span
                    className={classes.link}
                    role="presentation"
                    onClick={() => handleClick()}
                    test={'request-churn-cancel-link'}
                  >
                    {'click here.'}
                  </span>
                </>
            )}
    />
  );
};

RequestChurnCancel.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default RequestChurnCancel;
